module.exports = __webpack_public_path__ + "img/ic-tag.173bc785.svg";